import API from "./index";

export const getAllBlogs = async (params) => {
  const response = await API.get("/blogs", { params });
  return response.data;
};

export const getBlogById = async (id) => {
  const response = await API.get(`/blogs/${id}`);
  return response.data;
};

export const createBlog = async (payload) => {
  const response = await API.post("/blogs", payload);
  return response.data;
};

export const updateBlog = async (id, payload) => {
  const response = await API.put(`/blogs/${id}`, payload);
  return response.data;
};

export const deleteBlog = async (id) => {
  const response = await API.delete(`/blogs/${id}`);
  return response.data;
};

// Blog Page Settings
export const getBlogPageData = async () => {
  const response = await API.get("/blog-page");
  return response.data;
};

export const updateBlogPageData = async (payload) => {
  const response = await API.post("/blog-page", payload);
  return response.data;
};
